// Файл AttachmentViewer.js

/**
 * Компонент выбирает подходящий просмотрщик вложения и открывает его в общей выдвижной панели.
 */

import DriverPanel from '../../DriverPanel';
import PDFViewer from '../../PDFViewer';
import FileViewer from '../FileViewer';
import { apiService } from '../../../services/api.js';



const AttachmentViewer = ({
    ID_document,
    extraParams,
    is_open,
    loadFileBlob,
    on_close,
    selected_file,
    tableName,
}) => {
    const load_selected_file = () => {
        if (typeof loadFileBlob === 'function') {
            return loadFileBlob(selected_file.name);
        }

        if (!tableName) {
            return null;
        }

        return apiService.get_file_blob_POST(tableName, {
            doc: ID_document,
            file: selected_file.name,
            ...(extraParams || {}),
        });
    };
    const can_load_by_endpoint = (
        typeof loadFileBlob === 'function'
        || Boolean(tableName)
    );

    return (
        <DriverPanel
            isOpen={is_open}
            title={selected_file?.display_name || selected_file?.name || 'Просмотр файла'}
            onClose={on_close}
            className="document-attachment-viewer"
            overlayClassName={selected_file?.ext === 'docx'
                ? 'document-attachment-overlay--transparent'
                : ''}
            scrollable={false}
        >
            {!selected_file ? (
                <div className="doc-card__empty">Файл не выбран</div>
            ) : selected_file.ext === 'pdf' ? (
                <PDFViewer
                    key={selected_file.name}
                    pdf_path={selected_file.pdf_path}
                    loadBlob={can_load_by_endpoint
                        ? load_selected_file
                        : null}
                />
            ) : (
                <FileViewer
                    fileName={selected_file.name}
                    ext={selected_file.ext}
                    loadBlob={load_selected_file}
                />
            )}
        </DriverPanel>
    );
};


export default AttachmentViewer;
